import { Injectable } from '@angular/core';
import { Observable, Subject, BehaviorSubject } from 'rxjs';
import { ExitFormModel } from '../user-details/exit-form/exit-form.model';
import { ActivatedRoute } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ExitFormService {
  private exitFormModel: ExitFormModel;
  getExitForm() {
    if (this.exitFormModel == null) {
      this.exitFormModel = new ExitFormModel();
    }
    return this.exitFormModel;
  }

  setExitForm(detail: ExitFormModel) {
    this.exitFormModel = detail;
  }

}
